export const MAPS = {
  STARTING_VILLAGE: {
    id: 'STARTING_VILLAGE',
    name: 'Money City',
    buildings: {
      townhall: {
        id: 'townhall',
        row: 2,
        col: 2,
        name: "Central Bank",
        emoji: '🏦',
        buildablePlot: '🏙️',
        storyBeatId: 'TOWNHALL_COMPLETE',
        starCost: 1
      },
      house: {
        id: 'house',
        row: 1,
        col: 2,
        name: 'Financial Office',
        emoji: '🏢',
        buildablePlot: '🏙️',
        storyBeatId: 'HOUSE_COMPLETE',
        starCost: 1
      },
      shop: {
        id: 'shop',
        row: 2,
        col: 3,
        name: 'Stock Exchange',
        emoji: '📈',
        buildablePlot: '🏙️',
        storyBeatId: 'SHOP_COMPLETE',
        starCost: 2
      },
      workshop: {
        id: 'workshop',
        row: 2,
        col: 1,
        name: 'Mint',
        emoji: '💰',
        buildablePlot: '🏙️',
        storyBeatId: 'WORKSHOP_COMPLETE',
        starCost: 2
      },
      warehouse: {
        id: 'warehouse',
        row: 3,
        col: 2,
        name: 'Treasury',
        emoji: '💎',
        buildablePlot: '🏙️',
        storyBeatId: 'WAREHOUSE_COMPLETE',
        starCost: 2
      },
      market: {
        id: 'market',
        row: 1,
        col: 3,
        name: 'Trading Floor',
        emoji: '📊',
        buildablePlot: '🏙️',
        storyBeatId: 'MARKET_COMPLETE',
        starCost: 2
      },
      temple: {
        id: 'temple',
        row: 3,
        col: 3,
        name: 'Investment Bank',
        emoji: '💹',
        buildablePlot: '🏙️',
        storyBeatId: 'TEMPLE_COMPLETE',
        starCost: 5
      }
    },
    decorations: [
      { row: 0, col: 0, emoji: '🏙️' },
      { row: 0, col: 4, emoji: '🏙️' },
      { row: 4, col: 0, emoji: '🏙️' },
      { row: 4, col: 4, emoji: '🏙️' },
      { row: 0, col: 1, emoji: '💵' },
      { row: 1, col: 0, emoji: '🏙️' },
      { row: 3, col: 4, emoji: '💲' },
      { row: 4, col: 3, emoji: '🏙️' }
    ]
  }
};
